'use strict';

var React = require('react');
var styleHelper = require('../../helper/styleHelper');
var propConst = require('../../constants/propConst');


/**
 * 滑块
 */
var Slider = React.createClass({

  render: function () {
    var progress = styleHelper.getInt(this.props,propConst.PROGRESS);
    var value = this.props.w * progress / 100;
    var w = styleHelper.getWidth(this.props);
    var h = styleHelper.getHeight(this.props);
    var ch = this.props.h;
    var bg = styleHelper.getBackgroundColor(this.props);

    return (
      <div className="component-Slider">
        <span className="track-left" style={{
          top: h *0.5 -1,
          width:(progress === 100) ? (w - ch/2) : value,
          backgroundColor : bg
        }}/>
        <span className="track-right" style={{
          left: (progress === 0) ?(ch/2) : value,
          top: h *0.5 -1,
          width: (progress === 100) ? 0 : (progress === 0? (w - ch/2) : (w - value))
        }}/>
        <span className="slider" style={{
          left: Math.max(0,Math.min(value - ch/2,w - ch)),
          top: (h - ch)/2,
          width: ch,
          height : ch
        }}>
          <span className="slider-outer" style={{backgroundColor:bg}}/>
          <spane className="slider-inner" style={{
            left : (ch - 10)/2,
            top : (ch - 10)/2,
            backgroundColor:bg
          }}/>
        </span>
      </div>
    );
  }

});


module.exports = Slider;



/** WEBPACK FOOTER **
 ** ./src/views/Components/Slider.jsx
 **/